export const UPLOAD_DATE_TYPES = `
query uploadDateTypeList {
	uploadDateTypeList {
		__typename
		
		... on UploadDateType {
			id
			code
			label
			description
			active
			translation_key
			its
			uts
			dts
		}
		
		... on ResultError {
			status_code
			message
			message_translation_key
		}
	}
}
`;
